import {
  type EdgeData,
  type EdgeId,
  type PathLookupEdgeData,
  isPathLookupEdgeData,
} from '@ipfabric/utils';
import type { GraphState } from 'components/Graph/GraphState';
import type { GraphTooltipPayload } from 'components/Graph/GraphTooltip/GraphTooltipPayload';
import { createSelector } from 'reselect';
import { createScopedSelector } from 'utils/react/scopedSelector';

export const selectPathLookupEdgeTooltipEdgeData: (
  s: GraphState,
) => PathLookupEdgeData | null = createScopedSelector(() =>
  createSelector(
    (s) => s.tooltip?.payload,
    (s) => s.graph.edges,
    (
      payload: GraphTooltipPayload | undefined,
      edges: Record<EdgeId, EdgeData>,
    ) => {
      if (payload?.type !== 'pathLookupPathInspectorEdge') {
        return null;
      }
      const edgeData = edges[payload.edgeId] ?? null;
      if (edgeData === null || !isPathLookupEdgeData(edgeData)) {
        return null;
      }
      return edgeData;
    },
  ),
);
